const { get, orderBy, isEmpty, } = require('lodash');
const numeral = require('numeral');

const title = _ => get(_, 'AttributeSets.ItemAttributes.Title');
const smallImageUrl = _ => get(_, 'AttributeSets.ItemAttributes.SmallImage.URL');
const asin = _ => get(_, 'Identifiers.MarketplaceASIN.ASIN');
const condition = _ => get(_, 'Offers.Offer.ItemCondition') || ({ 11: 'New', })[get(_, 'listingReportData.コンディション')];
const price = _ => parseInt(get(_, 'Offers.Offer.BuyingPrice.ListingPrice.Amount') || get(_, 'listingReportData.価格'), 10);
const point = _ => parseInt(get(_, 'Offers.Offer.BuyingPrice.Points.PointsMonetaryValue.Amount'), 10);
const deliveryRouteValue = _ => _.Offers?.Offer?.FulfillmentChannel || _.listingReportData?.['フルフィルメント・チャンネル'];
const cmSizes = (amazonProduct) => {
  const PackageDimensions = amazonProduct?.AttributeSets?.ItemAttributes.PackageDimensions;
  const packageDimensions = amazonProduct?.attributes?.item_package_dimensions?.[0];
  if([PackageDimensions?.Width, packageDimensions?.width].every(_ => _ == null)) return [];

  const [width, height, length] = [['Width', 'width'], ['Height', 'height'], ['Length', 'length']].map(([field1, field2]) => {
    return PackageDimensions ? (numeral(PackageDimensions[field1]?.Value).value() * 2.54) : (numeral(packageDimensions?.[field2].value).value() * (({ millimeters: 0.1, centimeters: 1, inches: 2.54, })[packageDimensions?.[field2].unit] || 0));
  });
  return width ? [width, height, length] : [];
};
const kgWeight = (amazonProduct) => {
  if(amazonProduct == null) return;

  const { Weight} = amazonProduct.AttributeSets.ItemAttributes.PackageDimensions || {};
  return Weight ? parseFloat(Weight.Value, 10) * 453.592 / 1000 : 0;
};
const computeAmazonProductSizeType = (amazonProduct) => {
  if(amazonProduct == null) return 'unknown';
  const _cmSizes = cmSizes(amazonProduct);
  if(isEmpty(_cmSizes)) return 'unknown';

  const borderSizes = [45, 35, 20];
  const isLarge = orderBy(cmSizes(amazonProduct), _ => _, 'desc').some((_, i) => _ > borderSizes[i]) || kgWeight(amazonProduct) > 9;
  return isLarge ? 'large' : 'small';
};

module.exports = {
  title,
  smallImageUrl,
  asin,
  condition,
  price,
  point,
  deliveryRouteValue,
  cmSizes,
  kgWeight,
  computeAmazonProductSizeType,
};
